import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { ListTableComponent } from '@ppl/ui';
import { BaseComponent } from '../../../../shared/utils/base.component';
import { FormBuilder, FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { SectionsService } from '../../../../services/sections.service';
import { AddressComponent } from '../../../../shared/components/address/address.component';
import { LeadDetailsService } from '../../../../services/lead-details.service';
import { LeadDetailsAddressComponent } from "../../../../shared/components/lead-details-address/lead-details-address.component";
import { NgZorroModule } from '../../../../shared/modules/ng-zorro/ng-zorro.module';
import { performValidation } from '../../../../shared/utils/validation.util';
import { AuthorizeDirective } from '../../../../shared/authorization/authorize.directive.';
import { RADIO_YES_NO_OPTIONS, STATIC_DATA } from '../../../../shared/constants/static-data.constants';
import { CommonModule } from '@angular/common';
import { ButtonComponent } from '@ppl/ui';
import { DropdownSelectComponent } from '@ppl/ui';
import { environment } from '../../../../../environments/environment';

@Component({
  selector: 'ppl-lead-detail-address-info',
  standalone: true,
  imports: [ListTableComponent,
    FormsModule,
    CommonModule,
    NgZorroModule,
    ReactiveFormsModule,
    AddressComponent,
    LeadDetailsAddressComponent,
    AuthorizeDirective,
    ButtonComponent,
    DropdownSelectComponent
  ],
  templateUrl: './lead-detail-address-info.component.html',
  styleUrl: './lead-detail-address-info.component.css'
})
export class LeadDetailAddressInfoComponent extends BaseComponent implements OnInit, OnChanges {

  mode = "read";
  filledInfo!: any;
  contactForm!: FormGroup;
  communicationType: any[] = [];
  steps: any;
  statesList: any;
  validationErrorsPermanentAdd = {};
  validationErrorsMailingAdd = {};
  validationErrorsServiceAdd = {};
  approvedStatus: string = STATIC_DATA.APPROVED;
  radioOptions = RADIO_YES_NO_OPTIONS.concat({
    label: 'Unknown',
    value: 'unknown'
  });
  leadStatus = '';

  @Input() pageId = '';
  @Input() tabId = '';
  @Input() programCode = '';

  @Input() set sectionData(data: any) {
    this.steps = data
  }

  @Input() entry!: string;
  @Input() selectedLeadId!: number;
  @Input() readOnly = false;

  @Output() leadUpdated = new EventEmitter<boolean>();

  constructor(
    private fb: FormBuilder,
    private sectionService: SectionsService,
    private leadDetailsService: LeadDetailsService
  ) {
    super();
    this.radioOptions.push({ label: 'Unknown', value: 'unknown' });
  }


  ngOnInit(): void {


    this.createFormGroup();

    this.statesList = this.lookupService.getLookupValue('STATE');
    this.leadDetailsService.getLeadStatus().subscribe((status: string) => {
      this.leadStatus = status;

    });

    if (this.mode == "read") {
      this.leadDetailsService.getUpdatedLeadData().subscribe(
        (data) => {
          this.filledInfo = data?.responsedata?.communicationData;
          if (this.filledInfo) {
            this.filledInfo['residentGt18'] = data?.responsedata?.infoData?.residentGt18;
          }


        }
      )
    }

    this.communicationType = this.lookupService.getLookupValue("Communication_Type");

  }

  ngOnChanges(changes: SimpleChanges) {
    try {
      if (changes['sectionData'] && changes['sectionData'].currentValue) {
        this.secData = this.steps['communication_data_address'];
      }
    } catch (e) {
      console.log('Error in getting section data and updating latest info', e);
    }
  }

  // ngOnDestroy(): void {
  //   unsubscribe to ensure no memory leaks
  // }


  createFormGroup(): void {
    this.contactForm = this.fb.group({
      leadId: [],
      residentGt18: [null],
      permanentAddress: this.fb.group({
        leadId: [],
        street1: [],
        street2: [],
        city: [],
        state: [''],
        zipCode: [],
        countyOrRegion: [],
        psd_code: [''],
        mailing: [false]
      }),
      mailingAddress: this.fb.group({
        leadId: [],
        street1: [],
        street2: [],
        city: [],
        state: [],
        zipCode: [],
        countyOrRegion: [],
        psd_code: [''],
        mailing: [true]
      }),
      serviceAddress: this.fb.group({
        leadId: [],
        street1: [],
        street2: [],
        city: [],
        state: [],
        zipCode: [],
        countyOrRegion: [],
        psd_code: [''],
        mailing: [true]
      })
    });
  }

  action(event: any) {
    console.log("acto", event)
  }

  cancelEdit() {
    this.mode = 'read';
    this.validationErrors = {};
    this.validationErrorsPermanentAdd = {};
    this.validationErrorsMailingAdd = {};
    this.validationErrorsServiceAdd = {};
    this.contactForm.reset();
  }

  getValue(code: string) {
    return this.lookupService.getLookupName(this.communicationType, code);
  }

  getFormGroup(controlName: string): FormGroup {
    return this.contactForm.get(controlName) as FormGroup;
  }


  editInfo() {
    this.mode = 'edit';
    this.contactForm.patchValue(this.filledInfo);
    this.contactForm.controls['leadId'].setValue(this.filledInfo?.permanentAddress?.leadId || this.selectedLeadId);
  }


  save() {

    const formData = this.contactForm.getRawValue();

    if (formData.permanentAddress.mailing) {
      delete formData.mailingAddress;
      this.validationErrorsMailingAdd = {};
      this.validationErrorsServiceAdd = {};
    }

    const serviceAddressConfigurationExists = this.secData?.attributes?.some((attribute: any) => attribute.fieldName === 'serviceAddress');


    if (!serviceAddressConfigurationExists){
      delete formData.serviceAddress;
    }
    
    try {
      this.validationErrorsPermanentAdd = performValidation(formData.permanentAddress, this.secData, 'Next', undefined, undefined, this.sectionService.getFlow(), this.sectionService.getEnrollmentType());
      if (!formData.permanentAddress.mailing) {
        this.validationErrorsMailingAdd = performValidation(formData.mailingAddress, this.secData, 'Next', undefined, undefined, this.sectionService.getFlow(), this.sectionService.getEnrollmentType());
        if (serviceAddressConfigurationExists) {
          this.validationErrorsServiceAdd = performValidation(formData.serviceAddress, this.secData, 'Next', undefined, undefined, this.sectionService.getFlow(), this.sectionService.getEnrollmentType());
        }
      }
    } catch {
      console.log("Error in validations");
    }

    this.applyCaliforniaOnlyStateError(formData);

    // save data to server if no validation errors
    if (Object.keys(this.validationErrorsPermanentAdd).length == 0 && Object.keys(this.validationErrorsMailingAdd).length == 0 && Object.keys(this.validationErrorsServiceAdd).length == 0) {

      const payload = this.preparePayload(formData);
      // save data to server 
      this.leadDetailsService.updateLeadAddress(payload, this.entry).subscribe(
        {
          next: () => {
            this.leadUpdated.emit(true);
            this.cancelEdit();
          },
          error: () => {
            this.leadUpdated.emit(true);
            this.cancelEdit();
          }
        }
      )
    }

  }


  // For the CASDP participant enrollment flow only, the physical and mailing
  // address states must be California. Otherwise, block save and show the error
  // on the respective state field. Controlled by the same environment flag.
  private applyCaliforniaOnlyStateError(formData: any): void {
    if (environment.enableCaliforniaAddressValidation === false) {
      return;
    }
    const isCasdpEnrollment =
      this.sectionService.getFlow() === STATIC_DATA.PARTICIPANT_ENROLLMENT &&
      this.programCode === STATIC_DATA.CASDP_PROGRAM_CODE;
    if (!isCasdpEnrollment) {
      return;
    }
    this.validationErrorsPermanentAdd = this.flagNonCaliforniaState(
      formData?.permanentAddress?.state,
      this.validationErrorsPermanentAdd,
    );
    // The mailing address is only captured when it differs from the physical one.
    if (!formData?.permanentAddress?.mailing) {
      this.validationErrorsMailingAdd = this.flagNonCaliforniaState(
        formData?.mailingAddress?.state,
        this.validationErrorsMailingAdd,
      );
    }
  }

  // Returns the errors object with a California-only state error added when the
  // provided state isn't California; otherwise returns it unchanged.
  private flagNonCaliforniaState(stateValue: any, errors: any): any {
    const state = (stateValue ?? '').toString().trim().toUpperCase();
    if (state && !STATIC_DATA.CALIFORNIA_STATE_VALUES.includes(state)) {
      return { ...(errors || {}), state: STATIC_DATA.CALIFORNIA_ONLY_MESSAGE };
    }
    return errors;
  }

  preparePayload(source: any) {

    let payload: any = { ...source };

    payload = {
      ...payload,
      id: this.selectedLeadId,
      programCode: this.programCode
    };

    if (this.filledInfo?.permanentAddress?.modifiedDate && payload?.permanentAddress) {
      payload = {
        ...payload,
        permanentAddress: {
          ...payload.permanentAddress,
          modifiedDate: this.filledInfo.permanentAddress.modifiedDate
        }
      };
    }
    if (this.filledInfo?.mailingAddress?.modifiedDate && payload?.mailingAddress) {
      payload = {
        ...payload,
        mailingAddress: {
          ...payload.mailingAddress,
          modifiedDate: this.filledInfo.mailingAddress.modifiedDate
        }
      };
    }

    if (this.filledInfo?.serviceAddress?.modifiedDate && payload?.serviceAddress) {
      payload = {
        ...payload,
        serviceAddress: {
          ...payload.serviceAddress,
          modifiedDate: this.filledInfo.serviceAddress.modifiedDate
        }
      };
    }

    return payload;
  }

}
